export default __webpack_public_path__ + "static/media/gm-sb-girl.ad57f686.webp";